import { Dispatch, SetStateAction } from 'react';
import { StrategyPhase, WeeklyTask } from '../ProfitScenario/types';

export const useTaskOperations = (setPhases: Dispatch<SetStateAction<StrategyPhase[]>>) => {
    /**
     * 添加任务到指定周
     */
    const addTask = (phaseId: string, weekIndex: number, content: string, priority: 'high' | 'medium' | 'low' = 'medium', startDate: string, endDate: string) => {
        if (!content.trim() || !startDate || !endDate) return;

        setPhases(prev => prev.map(phase => {
            if (phase.id === phaseId) {
                const newWeeks = [...phase.weeks];
                const week = { ...newWeeks[weekIndex] };
                const tasks = week.tasks || [];

                const newTask = {
                    id: `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                    content: content.trim(),
                    completed: false,
                    priority,
                    startDate,
                    endDate
                };

                week.tasks = [...tasks, newTask];
                newWeeks[weekIndex] = week;
                return { ...phase, weeks: newWeeks };
            }
            return phase;
        }));
    };

    /**
     * 更新任务
     */
    const updateTask = (
        phaseId: string,
        weekIndex: number,
        taskId: string,
        updates: Partial<{ content: string; priority: 'high' | 'medium' | 'low' }>
    ) => {
        setPhases(prev => prev.map(phase => {
            if (phase.id === phaseId) {
                const newWeeks = [...phase.weeks];
                const week = { ...newWeeks[weekIndex] };
                const tasks = week.tasks || [];

                week.tasks = tasks.map((task: WeeklyTask) =>
                    task.id === taskId ? { ...task, ...updates } : task
                );

                newWeeks[weekIndex] = week;
                return { ...phase, weeks: newWeeks };
            }
            return phase;
        }));
    };

    /**
     * 删除任务
     */
    const deleteTask = (phaseId: string, weekIndex: number, taskId: string) => {
        setPhases(prev => prev.map(phase => {
            if (phase.id === phaseId) {
                const newWeeks = [...phase.weeks];
                const week = { ...newWeeks[weekIndex] };
                const tasks = week.tasks || [];

                week.tasks = tasks.filter((task: WeeklyTask) => task.id !== taskId);
                newWeeks[weekIndex] = week;
                return { ...phase, weeks: newWeeks };
            }
            return phase;
        }));
    };

    /**
     * 切换任务完成状态
     */
    const toggleTaskCompletion = (phaseId: string, weekIndex: number, taskId: string) => {
        setPhases(prev => prev.map(phase => {
            if (phase.id === phaseId) {
                const newWeeks = [...phase.weeks];
                const week = { ...newWeeks[weekIndex] };
                const tasks = week.tasks || [];

                week.tasks = tasks.map((task: WeeklyTask) =>
                    task.id === taskId ? { ...task, completed: !task.completed } : task
                );

                newWeeks[weekIndex] = week;
                return { ...phase, weeks: newWeeks };
            }
            return phase;
        }));
    };

    /**
     * 清空已完成的任务
     */
    const clearCompletedTasks = (phaseId: string, weekIndex: number) => {
        setPhases(prev => prev.map(phase => {
            if (phase.id === phaseId) {
                const newWeeks = [...phase.weeks];
                const week = { ...newWeeks[weekIndex] };
                const tasks = week.tasks || [];

                week.tasks = tasks.filter((task: WeeklyTask) => !task.completed);
                newWeeks[weekIndex] = week;
                return { ...phase, weeks: newWeeks };
            }
            return phase;
        }));
    };

    return {
        addTask,
        updateTask,
        deleteTask,
        toggleTaskCompletion,
        clearCompletedTasks
    };
};
